import React from "react";
import LeaveRequestForm from "../components/features/leaves/LeaveRequestForm";
import { MainLayout } from "../components/layout";
import { useNavigate } from "../lib/router";
import { useAuth } from "../hooks/useAuth";

export const LeaveRequestPage: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAdminOrHR = user?.role === "admin" || user?.role === "hr";

  const handleSuccess = (targetUserId?: string) => {
    // If admin/HR created request for another employee, navigate to filtered list
    if (isAdminOrHR && targetUserId) {
      // Navigate to leaves list with filters: all requests, specific employee, pending status
      setTimeout(() => {
        navigate(`/leaves?viewMode=all&userId=${targetUserId}&status=pending`);
      }, 1500);
    } else {
      // Regular user: redirect to their own leave list
      setTimeout(() => {
        navigate("/leaves");
      }, 1500);
    }
  };

  const handleCancel = () => {
    navigate("/");
  };

  return (
    <MainLayout title="คำขอลาใหม่">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100">
            คำขอลาใหม่
          </h1>
          <p className="mt-2 text-gray-600 dark:text-gray-400">
            ส่งคำขอลาใหม่เพื่อขออนุมัติ
          </p>
        </div>

        {/* Form Card */}
        <div className="bg-white dark:bg-gray-800 shadow-md rounded-lg p-6 md:p-8">
          <LeaveRequestForm onSuccess={handleSuccess} onCancel={handleCancel} />
        </div>

        {/* Help Text */}
        <div className="mt-6 bg-blue-50 dark:bg-blue-950/50 border border-blue-200 dark:border-blue-900 rounded-lg p-4">
          <h3 className="text-sm font-semibold text-blue-900 dark:text-blue-100 mb-2">
            📌 ข้อมูลสำคัญ
          </h3>
          <ul className="text-sm text-blue-800 dark:text-blue-200 space-y-1 list-disc list-inside">
            <li>คำขอลาของคุณจะถูกส่งไปยังผู้จัดการเพื่อขออนุมัติ</li>
            <li>คุณจะได้รับการแจ้งเตือนเมื่อคำขอของคุณถูกตรวจสอบ</li>
            <li>บางประเภทของการลาอาจต้องมีเอกสารประกอบ</li>
            <li>ตรวจสอบยอดการลาก่อนส่งคำขอ</li>
          </ul>
        </div>
      </div>
    </MainLayout>
  );
};

export default LeaveRequestPage;
